module.exports = __webpack_public_path__ + "static/media/digitalrxMbg.5dd81bff.jpg";